<template>
	<div class="_pagina_statistiche_aziendali">

		<div class="d-flex flex-column" style="margin: 0 30px 20px;">
			<div data-tour-step-statistiche="1"
					 class="_semi_bold"
					 style="color:#434343; font-size:25px;"
			>
				Statistiche aziendali
			</div>

			<div data-tour-step-statistiche="2" class="d-flex align-center" style="flex: 1 1 auto">
				<div class="_semi_bold" style="font-size:18px; margin-right:25px;">Seleziona il periodo
					<v-icon :style="`margin-left:5px; font-size:20px; color:${scdColor}`">event</v-icon>
				</div>
				<div style="margin-right:25px;">
					<v-menu
						ref="dal"
						v-model="menuDal"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="90px"
					>
						<template v-slot:activator="{ on }">
							<div class="d-flex align-center">
								<div style="font-size:18px;">Dal</div>
								<v-text-field class="input_seleziona_periodo" style="width:120px; padding-left:7px;" :color="scdColor"
															clearable @click:clear="dateDal = null" readonly :value="dateITFormat(dateDal)"
															v-on="on"></v-text-field>
							</div>

						</template>
						<v-date-picker :color="scdColor" locale="it" v-model="dateDal" no-title
													 @input="menuDal = false"></v-date-picker>
					</v-menu>
				</div>
				<div style="margin-right:25px;">
					<v-menu
						ref="al"
						v-model="menuAl"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="90px"
					>
						<template v-slot:activator="{ on }">
							<div class="d-flex align-center">
								<div style="font-size:18px;">Al</div>
								<v-text-field class="input_seleziona_periodo" style="width:120px; padding-left:7px;" :color="scdColor"
															readonly clearable @click:clear="dateAl = null" :value="dateITFormat(dateAl)"
															v-on="on"></v-text-field>
							</div>
						</template>
						<v-date-picker :color="scdColor" locale="it" v-model="dateAl" no-title
													 @input="menuAl = false"></v-date-picker>
					</v-menu>
				</div>
			</div>

			<div class="d-flex align-center" style="width:715px;">
				<div class="_semi_bold" style="font-size:18px; margin-right:25px;">Scegli il bando</div>
				<v-select
					style="margin-right:25px;"
					item-text="nome"
					item-value="id"
					:items="bandi"
					v-model="bandoId"
					placeholder="Seleziona"
					:loading="isLoadingBandi"
				></v-select>
				<v-btn depressed :color="scdColor" class="_semi_bold"
							 style="color:white; text-transform:none; letter-spacing:1px; padding:0 30px;" rounded
							 @click="getStats()">Conferma
				</v-btn>
			</div>
		</div>

		<!-- <v-row class="mt-4" align="center">
				<v-col cols="12" md="2" class="headline black--text">
						<v-row justify="center">STATISTICHE</v-row>
						<v-row justify="center">AZIENDALI</v-row>
				</v-col>
				<v-col cols="12" md="5" offset-md="5">
						<v-card :style="'border: 1.5px solid ' + scdColor">
								<v-card-text class="pb-0 pt-2">
										<v-row justify="center" class="subtitle-1">Seleziona il periodo</v-row>
										<v-row align="center" justify="space-around" no-gutters>
												<v-col cols="10" sm="4" class="my-0">
														<v-menu
																ref="dal"
																v-model="menuDal"
																:close-on-content-click="false"
																transition="scale-transition"
																offset-y
																max-width="290px"
																min-width="290px"
														>
																<template v-slot:activator="{ on }">
																		<v-text-field label="Dal" clearable @click:clear="dateDal = null" readonly :value="dateITFormat(dateDal)" prepend-icon="event" v-on="on"></v-text-field>
																</template>
																<v-date-picker locale="it" v-model="dateDal" no-title @input="menuDal = false"></v-date-picker>
														</v-menu>
												</v-col>
												<v-col cols="10" sm="4" class="my-0">
														<v-menu
																ref="al"
																v-model="menuAl"
																:close-on-content-click="false"
																transition="scale-transition"
																offset-y
																max-width="290px"
																min-width="290px"
														>
																<template v-slot:activator="{ on }">
																		<v-text-field readonly clearable @click:clear="dateAl = null" label="Al" :value="dateITFormat(dateAl)" prepend-icon="event" v-on="on"></v-text-field>
																</template>
																<v-date-picker locale="it" v-model="dateAl" no-title @input="menuAl = false"></v-date-picker>
														</v-menu>
												</v-col>
												<v-col cols="10" sm="2" class="my-0">
														<v-btn @click="getStats()">Salva</v-btn>
												</v-col>
										</v-row>
								</v-card-text>
						</v-card>
				</v-col>
		</v-row>
		<v-divider class="mt-6 mb-9"></v-divider> -->

		<v-row v-if="isLoadingSquadre || isLoadingStats" justify="center">
			<v-progress-circular class="mt-12" :color="scdColor" size="32" width="3" indeterminate></v-progress-circular>
		</v-row>

		<div v-else>
			<div style="background-color:white;">
				<v-row style="padding: 20px 50px;">
					<v-col data-tour-step-statistiche="3" style="margin-top:15px;" sm="4">
						<v-row style="color:#434343" class="_semi_bold">Tempo medio
							{{!isNaN(tempoMedioComplessivo) ? tempoMedioComplessivo + "s" : "-"}}
						</v-row>
						<v-row style="color:#434343" class="mb-3 _semi_bold">Simulazioni eseguite {{numSimulazioniComplessive}}
						</v-row>
						<chart-pie-component :height="220" :chartData="pieChart"/>
					</v-col>
					<v-col sm="8">
						<chart-line-component data-tour-step-statistiche="4" :chartData="dataLineChart" :height="300"
																	:options="options"/>
					</v-col>
				</v-row>
			</div>

			<v-row class="mt-2">
				<v-col cols="6" md="4" class="mx-6">
					<v-text-field autocomplete="search-squadra" label="Cerca squadra" v-model="search" prepend-icon="search"/>
				</v-col>
			</v-row>
			<v-data-table
				data-tour-step-statistiche="5"
				class="mt-0 mx-2 mb-2 statistiche-data-table"
				:headers="headers"
				:items="tableStatsSquadre"
				no-data-text="Nessuna squadra trovato"
				:footer-props="{'items-per-page-options':[5, 15, 30], 'items-per-page-text': 'Squadre per pagina'}"
				:search="search"
			>
				<template slot="item" slot-scope="props">
					<tr class="_table_row">
						<td>{{props.item.classifica}}</td>
						<td>{{props.item.nome}}</td>
						<td style="color:white;"
								:class="`_semi_bold ${props.item.tempoMedio <= tempoDaBattere && props.item.tempoMedio != null ? ' bg_green' : (props.item.tempoMedio > tempoDaBattere && props.item.tempoMedio != null ? ' bg_red' : '')}`">
							{{props.item.tempoMedio ? props.item.tempoMedio + " s" : ""}}
						</td>
						<td>{{props.item.numSimulazioniEseguite}}</td>
						<td>{{props.item.percVincenti + "% (" + props.item.numVincenti + ")"}}</td>
						<td>{{props.item.percAbbandonate + "% (" + props.item.numAbbandonate + ")"}}</td>
						<td>
							<v-switch class="mt-0" inset hide-details
												:disabled="idsSquadreToShow.length == limitSquadreToShow && !idsSquadreToShow.includes(props.item.teamId)"
												:color="colorsSquadreToShow[idsSquadreToShow.indexOf(props.item.teamId)]"
												v-model="props.item.checkbox_value"
												@change="mostraNascondiGraficoSquadra(props.item.teamId)"></v-switch>
						</td>
					</tr>
				</template>
				<template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
					{{pageStart}} - {{pageStop}} di {{itemsLength}}
				</template>
			</v-data-table>
		</div>

	</div>
</template>


<script>
import mixin from '../../mixins';

export default {
	props: ['hideGuide'],
	data() {
		return {
			menuDal: null,
			dateDal: moment().subtract(6, 'days').format('YYYY-MM-DD'),
			menuAl: null,
			dateAl: moment().format('YYYY-MM-DD'),

			isLoadingBandi: false,
			bandi: [],
			bandoId: null,

			search: null,

			isLoadingSquadre: false,
			squadre: [],
			idSquadraSelezionata: null,

			isLoadingStats: false,

			pieChart: [],

			headers: [
				{text: '', value: 'classifica', searchable: false},
				{text: 'Squadra', value: 'nome'},
				{text: 'Tempo Medio', value: 'tempoMedio', searchable: false},
				{text: 'Simulazioni eseguite', value: 'numSimulazioniEseguite', searchable: false},
				{text: 'Simulazioni vincenti', value: 'percVincenti', searchable: false},
				{text: 'Simulazioni abbandonate', value: 'percAbbandonate', searchable: false},
				{text: 'Mostra nel grafico', value: 'show_chart', sortable: false, searchable: false}
			],

			dataLineChart: null, // Per il grafico
			options: {},

			tableStatsSquadre: [], // Per la tabella

			tempoDaBattere: null,
			tempoMedioComplessivo: null,
			numSimulazioniComplessive: null,
			numSimulazioniVinteComplessive: null,
			numSimulazioniAbbandonateComplessive: null,

			// Per le squadre da mostrare dinamicamente nel grafico:
			limitSquadreToShow: 3, // Costante!
			colorsSquadreToShow: ['blue', '#9d46ff', '#006400'],
			idsSquadreToShow: [],
		};
	},
	async created() {
		await this.getBandi();
		this.getStats();
	},
	methods: {
		getBandi() {
			this.isLoadingBandi = true;
			// this.isLoadingStats = true;
			return axios
				.get('/getBandi')
				.then(response => {
					this.bandoId = response.data.idBandoSelezionato;
					this.bandi = response.data.bandi;
				})
				.finally(() => {
					this.isLoadingBandi = false;
				})

		},
		getStats: function () {
			if (this.isLoadingStats) return;

			this.isLoadingStats = true;

			this.tableStatsSquadre.splice(0, this.tableStatsSquadre.length);

			let q = `/statistiche/cliente`;

			axios.get(q, {
					params: {
						data_dal: this.dateDal,
						data_al: this.dateAl,
						squadreToShow: this.idsSquadreToShow,
						bando_id: this.bandoId
					}
				})
				.then(response => {
					if (response.data.hasError) {
						this.alertType = "error";
						this.message = response.data.messages[0];
					} else {
						console.log(response.data.data)
						this.tempoDaBattere = parseFloat(response.data.data.tempoDaBattere);

						this.numSimulazioniComplessive = parseInt(response.data.data.totSimulazioniEffettuate);
						this.tempoMedioComplessivo = parseFloat(response.data.data.tempoMedio);

						this.numSimulazioniVinteComplessive = parseInt(response.data.data.numSimulazioniVinteComplessive);
						if (isNaN(this.numSimulazioniVinteComplessive)) this.numSimulazioniVinteComplessive = 0;

						this.numSimulazioniAbbandonateComplessive = parseInt(response.data.data.numSimulazioniAbbandonateComplessive);
						if (isNaN(this.numSimulazioniAbbandonateComplessive)) this.numSimulazioniAbbandonateComplessive = 0;

						this.pieChart = [
							this.numSimulazioniVinteComplessive,
							this.numSimulazioniComplessive - this.numSimulazioniVinteComplessive - this.numSimulazioniAbbandonateComplessive,
							this.numSimulazioniAbbandonateComplessive
						];

						// Aggiungo a ogni squadra un "checkbox_value" a false se il suo id non è presente nell'elenco degli ID da mostrare in grafico:

						this.tableStatsSquadre = response.data.data.stats_tabella;
						let self = this;
						this.tableStatsSquadre.forEach((elem) => {
							if (self.idsSquadreToShow.includes(elem.teamId)) elem.checkbox_value = true;
							else elem.checkbox_value = false;
						})

						// Dati per il grafico:
						let tutteLeSquadreTempiMedi = [];

						let tempoDaBattere = []; // Serve a generare la linea

						let counter = [];

						let medieSquadreDaMostrare = new Array(this.limitSquadreToShow); // Anche se poi i squadre magari sono 1 o 2
						for (var i = 0; i < this.limitSquadreToShow; i++) {
							medieSquadreDaMostrare[i] = [];
						}

						response.data.data.stats_grafico.forEach(function (riga, index) {
							tutteLeSquadreTempiMedi.push(parseFloat(riga.mediaTutteLeSquadre));

							for (let i = 0; i < riga.mediaSquadreToShow.length; i++) {
								medieSquadreDaMostrare[i].push(riga.mediaSquadreToShow[i]);
							}

							tempoDaBattere.push(self.tempoDaBattere);

							counter.push(""); // Senza di questo non funziona!
						})

						this.dataLineChart = {
							labels: counter,
							datasets: [
								{
									label: 'Tempo da battere',
									backgroundColor: 'rgba(5, 141, 199, .1)',//'#00ff0022',
									pointBackgroundColor: '#058dc7',
									pointRadius: 0,
									borderWidth: 1,
									// pointBorderColor: '#00ff00',
									borderColor: '#058dc7',
									data: tempoDaBattere
								},
								{
									label: 'Media dell\'Azienda (Solo Cliccatori con almeno 60 simulazioni svolte)',
									backgroundColor: '#0000ff00', // trasparente
									pointBackgroundColor: '#e69024',
									pointRadius: 1.3,
									borderWidth: 1,
									borderColor: '#e69024',
									// pointBorderColor: '#0000ff', // Bordino del pallino
									data: tutteLeSquadreTempiMedi
								},
							]
						};

						for (var i = 0; i < this.idsSquadreToShow.length; i++) {
							if (medieSquadreDaMostrare[i].length != 0) {
								let nome = null;
								this.tableStatsSquadre.some((squadra) => {
									// Prendo i nomi delle squadre
									if (squadra.teamId === self.idsSquadreToShow[i]) {
										nome = squadra.nome;
										return true;
									}
								});
								this.dataLineChart.datasets.push({
									label: `${nome}`,
									backgroundColor: '#0000ff00', // trasparente
									borderColor: `${this.colorsSquadreToShow[i]}`,
									pointRadius: 1.3,
									borderWidth: 1,
									// borderColor: `${this.colorsSquadreToShow[i]}`,
									// pointBorderColor: '#0000ff', // Bordino del pallino
									data: medieSquadreDaMostrare[i]
								})
							}
						}

						this.options = {
							title: {
								display: false
							},
							scales: {
								yAxes: [{
									scaleLabel: {
										display: true,
										labelString: 'Tempi (secondi)',
										fontSize: 16,
										fontFamily: "cursive",
										fontColor: '#6d94cd'
									},
									ticks: {
										beginAtZero: true
									},
									gridLines: {
										display: true
									}
								}],
								xAxes: [{
									display: true,
									scaleLabel: {
										display: true,
										labelString: '# Simulazioni',
										fontColor: '#6d94cd',
										fontFamily: "cursive",
										fontSize: 14,
										padding: {
											top: 0
										}
									},
									gridLines: {
										display: false
									}
								}]
							},
							legend: {
								display: true
							},
							responsive: true,
							maintainAspectRatio: false
						}
					}
				})
				.catch(error => {
					console.log(error);
					this.alertType = "error";
					this.message = "Errore recuperando le statistiche della Squadra";
				})
				.finally(() => {
					this.isLoadingStats = false;
				});

		},
		mostraNascondiGraficoSquadra: function (squadraId) {
			// Ridondanza necessaria (necessario avere sia idsSquadreToShow sia il valore nella singola squadra)
			// l'elemento v-checkbox si occupa di mettere a true/false il bool associato al v-model
			if (this.idsSquadreToShow.includes(squadraId)) {
				this.idsSquadreToShow.splice(this.idsSquadreToShow.indexOf(squadraId), 1);
				this.getStats();
			} else if (this.idsSquadreToShow.length < this.limitSquadreToShow) {
				this.idsSquadreToShow.push(squadraId);
				this.getStats();
			} else {
				this.alertType = 'error';
				this.message = `Non può mostrare più di ${this.limitSquadreToShow} squadre per volta`;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
._pagina_statistiche_aziendali {
	font-family: 'Montserrat', sans-serif !important;
	font-size: 14px;
	color: #6D94CD;
	font-weight: 400;
	line-height: 1.5;
	padding-top: 20px;
}

._medium {
	font-weight: 500;
}

._semi_bold {
	font-weight: 600;
}

::v-deep .statistiche-data-table {
	background-color: #eeeeee;
	color: #434343 !important;

	& .v-data-table-header tr th {
		border-bottom: none !important;
		color: #6d94cd !important;
		// height: 18px;
		// font-size: 15px;
		text-align: center !important;
		// &:not(:nth-child(2)) {
		//   color: #6d94cd;
		// }
		// &:nth-child(2) {
		//   color: #fff;
		//   background-color: #e6901c;
		// }
	}

}

::v-deep .statistiche-data-table ._table_row {
	& td {
		border-bottom: 0 !important;
		font-size: 13px;
		text-align: center;
		height: 40px;

		&.bg_green {
			background-color: #8bba40 !important;
		}

		&.bg_red {
			background-color: #bc2025 !important;
		}
	}

}

::v-deep .statistiche-data-table .v-data-footer {
	color: #434343;
	font-weight: 600;
	border-top: none !important;

	& .v-data-footer__select {
		margin-left: 4% !important;
	}
}
</style>